import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { ContactsManager } from "@/components/app/contacts-manager";

export const Route = createFileRoute("/_authenticated/t1dwpanel/contacts")({
  head: () => ({
    meta: [
      { title: "All contacts | Warrior Volunteer admin" },
      {
        name: "description",
        content: "Every outreach contact across the volunteer team, with owners and activity.",
      },
      { property: "og:title", content: "All contacts | Warrior Volunteer admin" },
      {
        property: "og:description",
        content: "Every outreach contact across the volunteer team, with owners and activity.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminContactsPage,
});

function AdminContactsPage() {
  return (
    <AppShell eyebrow="Admin" title="All contacts">
      <ContactsManager scope="all" />
    </AppShell>
  );
}
